import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared/shared.module';
import { TracksOverviewComponent } from './tracks-overview/tracks-overview.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatSelectModule,
    MatTabsModule,
    MatSlideToggleModule
  ],
  declarations: [TracksOverviewComponent],
  exports: [TracksOverviewComponent]
})
export class GameModule {}
